import moment from 'moment';
import { getDate } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

import { DateFormats } from '../../../common/constants/date';
import { Regions, regionTimezones } from '../../../common/model/account/regions';

export const daysInWeek = 7;

export const monthsInYear = 12;

export const msInDay = 1000 * 60 * 60 * 24;

export const getCurrentDate = () => {
    return new Date();
};

export const getDateMonthBefore = (): Date => {
    const now = getCurrentDate();
    now.setMonth(now.getMonth() - 1);
    return now;
};

export const getDateDaysBefore = (days: number): Date => {
    const now = getCurrentDate();
    now.setDate(now.getDate() - days);
    return now;
};

export const formatDate = (date: Date, format = DateFormats.dateTimeFormat, locale = 'en'): string => {
    return moment(date).locale(locale).format(format);
};

export const formatUtcDate = (date: Date, format = DateFormats.dateTimeFormat): string => {
    return moment(date).utc().format(format);
};

export const isValidDate = (d: any): boolean => {
    return moment(d).isValid();
};

export const getMonthNumberFromJsMonth = (jsMonth: number): string => {
    return jsMonth + 1 < 10 ? `0${jsMonth + 1}` : `${jsMonth + 1}`;
};

export const getCurrentTimezoneOffset = () => new Date().getTimezoneOffset();

export const getDayOfMonth = (date: Date, timezone: string): number => {
    const zonedTime = toZonedTime(date, timezone);
    return getDate(zonedTime);
};


export const daysBetweenDates = (date1: Date, date2: Date): number => {
    const diffInMs = Math.abs(date2.getTime() - date1.getTime());
    return Math.floor(diffInMs / msInDay);
};

export const getLKFormattedDateWithTimezone = (date?: Date, format?: keyof typeof DateFormats, timezone?: string): string | null => {
    if (!date) {
        return null;
    }

    const zonedTime = toZonedTime(date, timezone ?? regionTimezones[Regions.SverdlovskajaOblast]);
    return moment(zonedTime).format(format ?? DateFormats.dateFullTimeFormat);
};

export const getMonthName = (monthNumber: number) => {
    const date = new Date(2026, monthNumber - 1, 1);

    return date.toLocaleString('ru-RU', { month: 'long' });
};
